import React from 'react';
import PropTypes from 'prop-types';
import SimpleChartJSBarChart from '@components/Charts/SimpleChartJSBarChart/SimpleChartJSBarChart';
import { useTheme } from '@hooks';
import { NoDataAvailable } from '@components/Display';

function PowerManagementChart({ loading, series, categories }) {
  const { theme } = useTheme();
  const {
    palette: {
      charts: { colorsSameType }
    }
  } = theme;
  const displayUnit = '%';

  // transform series into per-category datasets for horizontal bars
  const chartSeries = (categories || []).map((cat, idx) => ({
    label: cat,
    data: [{ x: cat, y: series?.[0]?.data?.[idx] ?? series?.[0]?.[idx] ?? 0 }],
    borderColor: colorsSameType[0],
    backgroundColor: colorsSameType[0],
    barPercentage: 0.6,
    borderSkipped: true,
    unit: displayUnit
  }));

  if (!loading && (!series.length || !categories?.length || NoDataAvailable.hasNoData(chartSeries))) {
    return <NoDataAvailable height="380px" />;
  }

  return (
    <SimpleChartJSBarChart
      id="power-management-chart"
      loading={loading}
      series={chartSeries}
      unit={displayUnit}
      tooltipTitle={'Energy'}
      // horizontal bars (categories on Y axis)
      isHorizontal
      height={'380px'}
    />
  );
}

PowerManagementChart.propTypes = {
  series: PropTypes.arrayOf(PropTypes.object),
  categories: PropTypes.arrayOf(PropTypes.string),
  loading: PropTypes.bool
};

PowerManagementChart.defaultProps = {
  series: [],
  categories: [],
  loading: false
};

export default PowerManagementChart;
